<template>
  <Link :href="href"
    class="flex items-center gap-3 px-3 py-2.5 rounded-xl text-sm font-medium transition"
    :class="isActive
      ? 'bg-indigo-50 dark:bg-indigo-950 text-indigo-600 dark:text-indigo-400'
      : 'text-slate-600 dark:text-slate-400 hover:bg-slate-100 dark:hover:bg-slate-800'">
    <span class="w-8 h-8 flex items-center justify-center rounded-lg transition"
      :class="isActive
        ? 'bg-indigo-100 dark:bg-indigo-900 text-indigo-600 dark:text-indigo-400'
        : 'bg-slate-100 dark:bg-slate-800'">
      <svg class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.8"
        v-html="icon" />
    </span>
    {{ label }}
  </Link>
</template>

<script setup>
import { computed } from 'vue'
import { Link, usePage } from '@inertiajs/vue3'

const props = defineProps({
  href: String,
  icon: String,
  label: String,
})

const page = usePage()
const isActive = computed(() => page.url.startsWith(props.href))
</script>
